<div class="content-wrapper">
    <div class="content-wrapper">
        <div class="content-body">

            <app-content-header [contentHeader]="contentHeader"></app-content-header>

            <!-- <div class="col-xl-9 col-md-8 col-12"> -->
            <div class="card">

                <h2 style="padding: 1%; font-weight: 500;">Fechamento de Clientes</h2>
                <hr>
                <!-- DATATABLE -->
                <ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
                    [reorderable]="true" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
                    style="box-shadow: none" [rows]="rows" [scrollbarH]="true" rowHeight="auto">

                    <!-- COLUNA -->
                    <ngx-datatable-column [sortable]="false" [width]="70">
                        <ng-template let-column="column" ngx-datatable-header-template>
                            <h4>CPF/CNPJ</h4>
                            <input type="search" placeholder="CPF/CNPJ" class="ml-25 form-control"
                                (keyup)="textFilterVeiculo($event, 'cpf_cnpj_cliente')" />
                        </ng-template>
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                            let-row="row">
                            <div class="datatable-row">
                                <span class="font-weight-bold">{{row.cpf_cnpj_cliente }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <!-- COLUNA -->
                    <ngx-datatable-column [sortable]="false">
                        <ng-template let-column="column" ngx-datatable-header-template>
                            <h4>Razão Social</h4>
                            <input type="search" placeholder="Razão Social" class="ml-25 form-control"
                                (keyup)="textFilterVeiculo($event, 'razao_social')" />
                        </ng-template>
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                            let-row="row">
                            <div class="datatable-row">
                                <span class="font-weight-bold">{{row.razao_social }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <!-- COLUNA -->
                    <ngx-datatable-column [sortable]="false">
                        <ng-template let-column="column" ngx-datatable-header-template>
                            <h4>Nome Fantasia</h4>
                            <input type="search" placeholder="Nome Fantasia" class="ml-25 form-control"
                                (keyup)="textFilterVeiculo($event, 'nome_fantasia')" />
                        </ng-template>
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                            let-row="row">
                            <div class="datatable-row">
                                <span class="font-weight-bold">{{row.nome_fantasia }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <!-- COLUNA -->
                    <ngx-datatable-column [sortable]="false" [width]="30">
                        <ng-template let-column="column" ngx-datatable-header-template>
                            <h4>VEÍCULOS</h4>
                        </ng-template>
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                            let-row="row">
                            <div class="datatable-row">
                                <span class="font-weight-bold">{{row.total_veiculo }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <!-- COLUNA -->
                    <ngx-datatable-column [sortable]="false" [width]="30">
                        <ng-template let-column="column" ngx-datatable-header-template>
                            <h4>CHIPS</h4>
                        </ng-template>
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                            let-row="row">
                            <div class="datatable-row">
                                <span class="font-weight-bold">{{ row.flg_chip === 1 ? row.total_chip : 0 }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <!-- COLUNA -->
                    <ngx-datatable-column [sortable]="false" [width]="30">
                        <ng-template let-column="column" ngx-datatable-header-template>
                            <h4>FALEFLEX</h4>
                        </ng-template>
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                            let-row="row">
                            <div class="datatable-row">
                                <span class="font-weight-bold">{{ row.total_servico }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <!-- COLUNA -->
                    <ngx-datatable-column [sortable]="false" [width]="50">
                        <ng-template let-column="column" ngx-datatable-header-template>
                            <h4>Ações</h4>
                        </ng-template>
                        <ng-template ngx-datatable-cell-template  let-rowIndex="rowIndex" let-value="value"
                            let-row="row">
                            <div class="datatable-row">
                                <button class="btn btn-secondary"
                                    routerLink="/fechamento/{{idFechamento}}/clientes/{{row.id_cliente}}">
                                    <span>Visualizar</span>
                                </button>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                </ngx-datatable>
            </div>

            <!-- </div> -->

        </div>
    </div>